import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Button, PhoneInput, SmartForm } from '@beef/legacy-ui-kit';
import LegalWithTooltip from "../../../../../LegalWithTooltip";
import Captcha from "../../../../../../FeedbackCaptcha";
import styles from "../../styles.pcss";
var cx = classNames.bind(styles);
export var RenderRequestFrom = function RenderRequestFrom(_ref) {
  var data = _ref.data;
  var phoneInputValue = data.phoneInputValue,
    changePhone = data.changePhone,
    texts = data.texts,
    showCaptcha = data.showCaptcha,
    reCaptchaModel = data.reCaptchaModel,
    onPhoneFocus = data.onPhoneFocus,
    onBackCallBtnClick = data.onBackCallBtnClick,
    phoneInputStatus = data.phoneInputStatus;
  return /*#__PURE__*/React.createElement(SmartForm, {
    className: cx('wrapper', 'requestForm'),
    onSubmit: onBackCallBtnClick,
    validator: {
      captchaInput: function captchaInput(value) {
        return {
          status: value.length < 5 ? 'fail' : 'ok',
          msg: value.length < 5 ? 'Пройдите капчу' : ''
        };
      }
    },
    "data-t-id": "components-RenderRequestFrom"
  }, showCaptcha && /*#__PURE__*/React.createElement("div", {
    className: cx('reCaptchaWrapper')
  }, /*#__PURE__*/React.createElement(Captcha, _extends({}, reCaptchaModel, {
    inputId: "captchaInput"
  }))), /*#__PURE__*/React.createElement("div", {
    className: cx('container')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('phoneLabel'),
    dangerouslySetInnerHTML: {
      __html: texts.phoneLabel
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('phoneInputWrapper')
  }, /*#__PURE__*/React.createElement(PhoneInput, {
    error: phoneInputStatus === 'fail' ? texts.wrongPhone : '',
    keepErrorIndent: false,
    onChange: changePhone,
    onFocus: onPhoneFocus,
    placeholder: null,
    size: "big",
    status: phoneInputStatus,
    value: phoneInputValue
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('phoneInputDescription'),
    dangerouslySetInnerHTML: {
      __html: texts.phoneInputDescription
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('backCallBtnWrapper')
  }, /*#__PURE__*/React.createElement(Button, {
    className: ['big', cx('backCallBtn')],
    transformer: true,
    type: "submit"
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: texts.backCallBtnText
    },
    "data-t-id": "components-RenderRequestFrom"
  })))), /*#__PURE__*/React.createElement(LegalWithTooltip, {
    termsOfUse: texts.termsOfUse,
    userAgreementText: texts.userAgreementText
  }));
};
RenderRequestFrom.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.shape({
    onPhoneFocus: PropTypes.func,
    onBackCallBtnClick: PropTypes.func,
    phoneInputValue: PropTypes.string,
    changePhone: PropTypes.func,
    showCaptcha: PropTypes.bool,
    captchaToken: PropTypes.string,
    reCaptchaModel: PropTypes.shape({
      captchaKey: PropTypes.string,
      refreshCaptcha: PropTypes.number,
      setCaptchaKey: PropTypes.func,
      onChange: PropTypes.func
    }),
    phoneInputStatus: PropTypes.string,
    texts: PropTypes.shape({
      phoneLabel: PropTypes.string,
      wrongPhone: PropTypes.string,
      phoneInputDescription: PropTypes.string,
      backCallBtnText: PropTypes.string,
      userAgreementText: PropTypes.string,
      termsOfUse: PropTypes.string
    })
  })
} : {};